export default __webpack_public_path__ + "static/media/IMG-20240708-WA0019.6bd6e7c6.jpg";